import React from 'react';

export const NotFound: React.FC = () => <>404 not found</>;
